import React, { useEffect, useState } from "react";
import TextInput from "../../../components/Input/TextInput";
import { Flex, Text } from "@mantine/core";
import { Pencil } from "tabler-icons-react";

const TextInputWithTextDisplay = (props) => {
  const [active, setActive] = useState(false);
  const ref = React.useRef(null);

  useEffect(() => {
    if (ref.current && active) {
      ref.current.focus();
    }
  }, [active, ref]);

  return (
    <Flex
      align="center"
      justify={"center"}
      style={{
        borderRadius: "5px",
      }}
    >
      <TextInput
        fullWidth
        {...props}
        onBlur={() => setActive(false)}
        ref={ref}
        type="number"
        style={{
          display: active ? "block" : "none",
        }}
        size="xs"
      />

      <Text
        onClick={() => setActive(true)}
        style={{
          cursor: "pointer",
          width: "100%",
          height: "100%",
          display: active ? "none" : "block",
          position: "relative",
          padding: 6,
        }}
        size={props.size ? props.size : "md"}
        align="center"
      >
        {props.type === "currency"
          ? parseInt(props.value).toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })
          : props.type === "percentage"
            ? `${props.value}%`
            : props.type === "months"
              ? `${props.value} months`
              : props.value + " " + props.type}

        <Pencil
          size={14}
          style={{
            position: "absolute",
            right: 5,
          }}
        />
      </Text>
    </Flex>
  );
};

export default TextInputWithTextDisplay;
